//функция присваивания класса стилей по условию [function of assigning classname by condition]
const cssIf = ( param, value, elsevalue = "" ) => param ? value : elsevalue;
export default cssIf;